import React, { useEffect } from "react";
import { InputCheck } from "../../../../controls";
import { useTranslation } from "react-i18next";
import { Collapse } from "@mui/material";

const UserAccess = ({ setFeaturesAccess, featuresAccess }) => {
  const { t } = useTranslation();

  useEffect(() => {
    if (!featuresAccess.id) {
      featuresAccess.isHaveUserAccess
        ? setFeaturesAccess((j) => ({
            ...j,
            userAccess: {
              isHaveAddAccess: true,
              isHaveExportAccess: true,
              isHaveEditAccess: true,
              isHaveDeleteAccess: true,
              isHaveActivatiInactiveAccess: true,
            },
          }))
        : setFeaturesAccess((j) => ({
            ...j,
            userAccess: {
              isHaveAddAccess: false,
              isHaveExportAccess: false,
              isHaveEditAccess: false,
              isHaveDeleteAccess: false,
              isHaveActivatiInactiveAccess: false,
            },
          }));
    }

    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [featuresAccess.isHaveUserAccess]);

  const handleInpChg = (e) => {
    const { name, checked } = e.target;
    setFeaturesAccess((j) => ({
      ...j,
      userAccess: { ...j.userAccess, [name]: checked },
    }));
  };

  return (
    <Collapse in={featuresAccess.isHaveUserAccess || false}>
      <div className="ml-25 d-grid g-5 mt-5">
        <InputCheck
          label={t("isHaveAddAccess")}
          checked={
            (featuresAccess.userAccess &&
              featuresAccess.userAccess.isHaveAddAccess) ||
            false
          }
          name={"isHaveAddAccess"}
          onClick={handleInpChg}
        />
        <InputCheck
          label={t("isHaveExportAccess")}
          checked={
            (featuresAccess.userAccess &&
              featuresAccess.userAccess.isHaveExportAccess) ||
            false
          }
          name={"isHaveExportAccess"}
          onClick={handleInpChg}
        />
        <InputCheck
          label={t("isHaveEditAccess")}
          checked={
            (featuresAccess.userAccess &&
              featuresAccess.userAccess.isHaveEditAccess) ||
            false
          }
          name={"isHaveEditAccess"}
          onClick={handleInpChg}
        />
        <InputCheck
          label={t("isHaveDeleteAccess")}
          checked={
            (featuresAccess.userAccess &&
              featuresAccess.userAccess.isHaveDeleteAccess) ||
            false
          }
          name={"isHaveDeleteAccess"}
          onClick={handleInpChg}
        />
        <InputCheck
          label={t("isHaveActivatiInactiveAccess")}
          checked={
            (featuresAccess.userAccess &&
              featuresAccess.userAccess.isHaveActivatiInactiveAccess) ||
            false
          }
          name={"isHaveActivatiInactiveAccess"}
          onClick={handleInpChg}
        />
      </div>
    </Collapse>
  );
};

export default UserAccess;
